import { Component } from '@angular/core';
import { DashboardService } from '@app/api/dmc';
import { TranslatePipe } from '@ngx-translate/core';
import { LoadingService } from '@app/core/services/loading.service';
import { ToastService } from '@app/core/services/toast.service';
import { ModalService } from '@app/core/services/modal.service';

@Component({
  selector: 'app-remove-lock',
  imports: [
    TranslatePipe
  ],
  templateUrl: './remove-lock.component.html',
  styleUrl: './remove-lock.component.css'
})
export class RemoveLockComponent {

  public element?: any;

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly loadingService: LoadingService,
    private readonly toastService: ToastService,
    private readonly modalService: ModalService
  ) {
  }

  public submit(): void {
    if (!this.element) return;

    const meteredDataLockIds = this.element.map((e: any) => e.id);

    if (meteredDataLockIds.length > 0) {
      this.loadingService.start();
      this.dashboardService.dashboardRemoveMeteredDataLocksPost({ meteredDataLockIds }).subscribe({
        next: (response) => {
          this.toastService.show('dashboard.lockedtimeseries.removelock.success')
          this.modalService.close()
        },
        complete: () => {
          this.loadingService.stop();
        }
      })
    }

  }
}
